"use client";

import type { ReactNode } from "react";

import { WorkspaceSessionGate } from "@/components/auth/workspace-session-gate";
import { EnterpriseAppChrome } from "@/components/layout";

export function WorkspaceShell({ children }: { children: ReactNode }) {
  return (
    <WorkspaceSessionGate>
      <EnterpriseAppChrome>{children}</EnterpriseAppChrome>
    </WorkspaceSessionGate>
  );
}
